
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M0 0h16v16H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M8 11.334a.645.645 0 00.475-.192.645.645 0 00.192-.475.645.645 0 00-.192-.475A.645.645 0 008 10a.645.645 0 00-.475.192.645.645 0 00-.192.475c0 .189.064.347.192.475a.645.645 0 00.475.192zm-.667-2.667h1.334v-4H7.333v4zm.667 6a6.492 6.492 0 01-2.6-.525 6.732 6.732 0 01-2.117-1.425A6.732 6.732 0 011.858 10.6 6.492 6.492 0 011.333 8c0-.922.175-1.789.525-2.6a6.732 6.732 0 011.425-2.117c.6-.6 1.306-1.075 2.117-1.424A6.492 6.492 0 018 1.333c.922 0 1.789.175 2.6.526.811.35 1.517.825 2.117 1.425.6.6 1.075 1.305 1.425 2.116.35.811.525 1.678.525 2.6 0 .922-.175 1.789-.525 2.6a6.732 6.732 0 01-1.425 2.117c-.6.6-1.306 1.075-2.117 1.425a6.492 6.492 0 01-2.6.525z","fill":"#B00020"}})])])
          )
        }
      }
    